module.exports = __webpack_public_path__ + "static/media/kasbonLogo.052d7698.png";